import React, {useEffect, useState} from 'react';
import {createOrder, getCart, removeFromCart} from '../api';
import {useNavigate} from 'react-router-dom';
import {saveOrderToHistory} from '../utils/orderHistory';
import './CartPage.css';

const formatPrice = (price) => `${Number(price).toLocaleString('ru-RU')} руб.`;

function CartPage() {
    const token = localStorage.getItem('token');
    const [cartItems, setCartItems] = useState([]);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('success');
    const navigate = useNavigate();

    const fetchCart = async () => {
        if (!token) {
            setMessageType('error');
            setMessage('Вы не авторизованы!');
            return;
        }

        const cartData = await getCart(token);
        setCartItems(cartData.items || []);
    };

    useEffect(() => {
        fetchCart();
        // eslint-disable-next-line
    }, []);

    const handleRemove = async (itemId) => {
        setMessage('');
        const res = await removeFromCart(token, itemId);
        setMessageType('success');
        setMessage(res.message === 'Item removed from cart' ? 'Товар удалён из корзины' : (res.message || 'Товар удалён из корзины'));
        fetchCart();
    };

    const handleOrder = async () => {
        setMessage('');
        const res = await createOrder(token);

        if (res.order_id) {
            saveOrderToHistory(res.order_id);
            setMessageType('success');
            setMessage(`Заказ #${res.order_id} успешно оформлен. Спасибо за покупку!`);
            setTimeout(() => {
                navigate(`/order/${res.order_id}`);
            }, 1200);
        } else {
            setMessageType('error');
            setMessage(res.message || 'Не удалось оформить заказ');
        }
    };

    const total = cartItems.reduce((acc, item) => acc + Number(item.price) * Number(item.quantity), 0);
    const totalQuantity = cartItems.reduce((acc, item) => acc + Number(item.quantity), 0);

    return (
        <section className="page cart-page" data-testid="cart-page">
            <header className="page-header cart-header">
                <div>
                    <p className="page-kicker">Покупки</p>
                    <h1 className="page-title">Моя корзина</h1>
                    <p className="page-subtitle">
                        Проверьте товары перед оформлением заказа.
                    </p>
                </div>
                <div className="cart-count" aria-label={`${cartItems.length} позиций в корзине`}>
                    <strong>{cartItems.length}</strong>
                    <span>позиций</span>
                </div>
            </header>

            {message && (
                <div className={`notice notice-${messageType} cart-message`}>
                    {message}
                </div>
            )}

            {cartItems.length === 0 ? (
                <div className="panel empty-state">
                    В корзине нет товаров
                </div>
            ) : (
                <div className="cart-layout">
                    <div className="cart-list panel">
                        {cartItems.map(ci => (
                            <article data-id="card-item" key={ci.item_id} className="cart-item">
                                <div className="cart-item-media">
                                    {ci.image_url ? (
                                        <img className="cart-item-image" src={ci.image_url} alt={ci.name} />
                                    ) : (
                                        <span className="cart-item-placeholder">Нет фото</span>
                                    )}
                                </div>

                                <div className="cart-item-main">
                                    <h2 className="cart-item-name">{ci.name}</h2>
                                    <p className="cart-item-description">{ci.description}</p>
                                    <div className="cart-item-facts">
                                        <span>Кол-во: {ci.quantity}</span>
                                        <span>{formatPrice(ci.price)} за шт.</span>
                                    </div>
                                </div>

                                <div className="cart-item-side">
                                    <strong className="cart-item-total">
                                        {formatPrice(Number(ci.price) * Number(ci.quantity))}
                                    </strong>
                                    <button
                                        type="button"
                                        className="btn btn-danger cart-remove-button"
                                        onClick={() => handleRemove(ci.item_id)}
                                    >
                                        Удалить
                                    </button>
                                </div>
                            </article>
                        ))}
                    </div>

                    <aside className="cart-summary panel" aria-label="Итог корзины">
                        <h2 className="cart-summary-title">Итого</h2>
                        <div className="cart-summary-row">
                            <span>Товаров</span>
                            <strong>{totalQuantity}</strong>
                        </div>
                        <div className="cart-summary-row cart-summary-total">
                            <span>Сумма</span>
                            <strong>{formatPrice(total)}</strong>
                        </div>
                        <button type="button" className="btn btn-success cart-checkout-button" onClick={handleOrder}>
                            Оформить заказ
                        </button>
                    </aside>
                </div>
            )}
        </section>
    );
}

export default CartPage;
